import React, { useCallback, useEffect, useState } from "react"
import styled from "styled-components"
import ListItem from "@/components/ExpandingListAndDescription/ListItem"
import { getMapKey } from "@/utils/utils"

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
`

export const NO_LIST_ITEM = {
	id: "",
	header: "",
	description: "",
	ref: undefined,
}

const List = ({ data, moreText = "", lestText = "", className = "", ...props }) => {
	const [activeItem, setActiveItem] = useState(NO_LIST_ITEM)
	const items = data || []

	const handleOutsideClick = useCallback(
		(e) => {
			const isChildOfActive = activeItem.ref.contains(e.target)
			if (isChildOfActive) return
			setActiveItem(NO_LIST_ITEM)
		},
		[activeItem],
	)

	// useEffect(() => {
	// 	console.log(activeItem);
	// }, [activeItem]);

	useEffect(() => {
		if (activeItem?.id) {
			window.addEventListener("click", handleOutsideClick, true)
		}

		return () => {
			window.removeEventListener("click", handleOutsideClick, true)
		}
	}, [handleOutsideClick, activeItem])

	return (
		<Wrapper className={`list ${className}`} {...props}>
			{items.map((item, index) => {
				const id = item?.id || ""
				const activeId = activeItem?.id || ""
				return (
					<ListItem
						key={getMapKey(item, index)}
						data={item}
						moreText={moreText}
						lestText={lestText}
						onClick={setActiveItem}
						active={activeId === id}
					/>
				)
			})}
		</Wrapper>
	)
}

export default List
